<template>
  <div class="container" :style="{ background: playColor }">
    <div class="audio-wrapper">
      <audio ref="audio">
        <source :src="myAudioUrl" />
      </audio>
      <div class="audio-left">
        <Icon class="play" type="md-volume-down" ref="audioPlayer" v-if="myPlayTemp" @click="myPlay()" />
        <Icon class="parse" type="md-volume-down" ref="audioPlayer" v-if="!myPlayTemp" @click="myPlay()"></Icon>

      </div>
      <div class="audio-right">
        <div class="audio-text" :style="{ color: playColor ? '#fff' : '' }">
          {{ playColor ? '听力考试正在进行中' : '点击开始听力考试······' }}
        </div>
        <playing v-if="!myPlayTemp" />
        <!-- <p style="max-width: 536px;"></p> -->
        <div class="audio-time" v-show="false">
          <span class="audio-length-current" ref="audioCurTime">00:00</span>
          <div class="progress-bar-bg" ref="progressBarBg" @mousedown="handledown()">
            <span ref="progressDot"></span>
            <div class="progress-bar" ref="progressBar"></div>
          </div>
          <span class="audio-length-total" ref="duration">00:00</span>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import playing from './playing.vue'
  export default {
    name: "myAudio",
    props: ["myAudioUrl"],
    data() {
      return {
        audio: "",
        myPlayTemp: true,
        playColor: ''
      };
    },
    mounted() {
      this.$bus.$on('updateAudio', (res) => {
        this.init()
      })
      this.init();
    },
    components: {
      playing
    },
    methods: {
      init() {
        if (!this.$refs.audio) return
        this.audio = this.$refs.audio;
        this.audio.load()
        this.myPlayTemp = true,
          this.playColor = ''
        // this.audio.pause();
        // this.updateProgress();
      },
      // 点击播放/暂停图片时，控制音乐的播放与暂停
      myPlay() {
        if (this.audio.paused) {
          // 开始播放当前点击的音频
          this.playColor = '#4b96e2'
          this.audio.play();
          this.myPlayTemp = false;
        } else {
          this.audio.pause();
          this.playColor = ''
          this.myPlayTemp = true;
        }
        this.updateProgress();
      },
      // 更新进度条与当前播放时间
      updateProgress() {
        // 进度条暂时不需要
        return
        let value = this.audio.currentTime / this.audio.duration;
        this.$refs.progressBar.style.width = value * 100 + "%";
        this.$refs.progressDot.style.left = value * 100 + "%";
        // 初始时间
        this.$refs.audioCurTime.innerHTML = this.transTime(this.audio.currentTime);
        // 总共时长
        let audioElement = new Audio(this.myAudioUrl);
        let self = this
        audioElement.addEventListener("loadedmetadata", function () {
          let duration2 = (audioElement.duration / 100).toFixed(2).replace('.', ':');
          self.$refs.duration.innerHTML = self.formatTime(duration2);
        });
      },
      // 播放结束时
      audioEnded() {
        this.$refs.progressBar.style.width = 0 + "%";
        this.$refs.progressDot.style.left = 0 + "%";
        this.playColor = ''
        this.myPlayTemp = true;
      },
      // 播放时间换算
      transTime(value) {
        let time = "";
        let h = parseInt(value / 3600);
        value %= 3600;
        let m = parseInt(value / 60);
        let s = parseInt(value % 60);
        if (h > 0) {
          time = this.formatTime(h + ":" + m + ":" + s);
        } else {
          time = this.formatTime(m + ":" + s);
        }
        return time;
      },
      //  * 格式化时间显示，补零对齐
      //  * eg：2:4  -->  02:04
      formatTime(value) {
        let time = "";
        let s = value.split(":");
        let i = 0;
        for (; i < s.length - 1; i++) {
          time += s[i].length == 1 ? "0" + s[i] : s[i];
          time += ":";
        }
        time += s[i].length == 1 ? "0" + s[i] : s[i];
        return time;
      },
      // 点击进度条跳到指定点播放
      handledown() {
        // 只有音乐开始播放后才可以调节，已经播放过但暂停了的也可以
        console.log(this.audio.currentTime);
        if (!this.audio.paused || this.audio.currentTime != 0) {
          let pgsWidth = this.$refs.progressBarBg.offsetWidth;
          let rate = event.offsetX / pgsWidth;
          this.audio.currentTime = this.audio.duration * rate;
          this.updateProgress();
        }
      }
    },
    watch: {
      audio: function (t) {
        let self = this;
        self.audio.addEventListener(
          "timeupdate",
          function () {
            // console.log('开始');
            self.updateProgress();
          },
          false
        );
        self.audio.addEventListener(
          "ended",
          function () {
            // console.log('结束');
            self.audioEnded();
          },
          false
        );
      }
    }
  };
</script>

<style lang="less" scoped>
  .container {
    position: relative;
    //   background-color: #fff;
    width: 100%;
    height: 36px;
    text-align: center;
  }
  .audio-wrapper {
    position: relative;
    width: 100%;
    height: 34px;
    text-align: center;
    margin: 0px auto;
    .audio-left {
      position: relative;
      display: inline-block;
      .audio-left icon {
        position: relative;
        top: 50%;
        margin: 0;
        cursor: pointer;
      }
    }
    .audio-right {
      position: relative;
      display: inline-block;
      width: 320px;
      height: 34px;
      font-size: 13px;
      .audio-text {
        position: relative;
        top: -4px;
      }
    }
  }
  .progress-bar-bg {
    background-color: #d9d9d9;
    position: relative;
    height: 2px;
    cursor: pointer;
  }
  .progress-bar {
    background-color: #649fec;
    width: 0;
    height: 2px;
  }
  .progress-bar-bg span {
    content: " ";
    width: 10px;
    height: 10px;
    border-radius: 50%;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    background-color: #3e87e8;
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -5px;
    margin-left: -5px;
    cursor: pointer;
  }
  .play {
    font-size: 32px;
    cursor: pointer;
  }
  .parse {
    font-size: 32px;
    color: #fff;
    cursor: pointer;
  }
  .audio-length-total {
    float: right;
    font-size: 12px;
  }
  .audio-length-current {
    float: left;
    font-size: 12px;
  }
</style>
